<template>
  <NavBar/>
  <QuiSommesNous/>
  <Valeurs2/>
  <Formulaire/>
  <Footer/>
</template>

<script>
import NavBar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Formulaire from "@/pages/Formulaire";
import QuiSommesNous from "@/components/QSN/Qui-sommes-nous";
import Valeurs2 from "@/components/QSN/Valeurs2";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Proprietaire",
  components: {Valeurs2, QuiSommesNous, Formulaire, Footer, NavBar}
}
</script>

<style scoped>

</style>